// 单文件引入方式

import Field from './ZuiField.vue'

export default {
  install(Vue) {
    Vue.component('ZuiField', Field)
  }
}

export { Field }
